export interface FileStorageResult {
  success: boolean;
  publicUrl?: string;
  error?: string;
}

export interface FileUploadOptions {
  customPath?: string;
  upsert?: boolean;
}

export const STORAGE_CONFIG = {
  BUCKET_NAME: 'email-attachments', // Korrigiert: Kleinschreibung wie im Supabase Dashboard
  MAX_ATTACHMENT_SIZE_MB: 4,
  MAX_TOTAL_SIZE_MB: 5.5, // Puffer für andere Request-Daten
  MAX_STORAGE_SIZE_MB: 50, // Korrekt: Supabase Storage unterstützt bis 50MB
} as const;